module.exports = __webpack_public_path__ + "img/casino-asia.cbd3cbdf.jpg";